import getApiClient from '@/plugins/api-client'

export default {
    loadSetting() {
        const self = this,
            api = getApiClient(self.$store),
            settingId = self.$route.params.id

        api.get(`settings/${settingId}`)
            .then(result => {
                self.setting = result.data
            })
            .catch(error => {
                console.log(error)
            })
    },

    updateSetting() {
        const self = this,
            api = getApiClient(self.$store),
            settingId = self.$route.params.id

        self.resetFormResult()

        api.patch(`settings/${settingId}`, self.setting, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(result => {
                self.setting = result.data
                self.success = true
            })
            .catch(error => {
                switch (error.response.status) {
                    case 400:
                    case 422:
                        let violations = error.response.data.violations
                        violations.forEach((violation) => {
                            self.errors[violation.propertyPath] = violation.message
                        })
                        break;
                }
            })
    },

    resetFormResult: function() {
        const self = this
        Object.keys(self.errors).forEach((error) => {
            self.errors[error] = null
        })
        self.success = false
    }
}
